export const domain='PopUpAlertsModel';export const onRemoveAlert=`${domain}/onRemoveAlert`;export const onAddAlert=`${domain}/onAddAlert`;